import React from "react";

import GradientButton from "../../UI/GradientButton";

import "./index.scss";
import { Button } from "antd";

interface WelcomeScreenProps {
  handleSelect: any;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ handleSelect }) => {
  return (
    <div className="welcome">
      <div className="welcome__card">
        <div className="welcome__image">
          <img src="/assets/images/welcome.svg" alt="Welcome illustration" />
        </div>

        <h2 className="welcome__title">Welcome to efone</h2>

        <p className="welcome__subtitle">
          To access all features, please choose one of the options below:
        </p>

        <GradientButton onClick={() => handleSelect("register")}>
          Register number
        </GradientButton>

        <div className="welcome__divider">
          <span>OR</span>
        </div>

        <Button onClick={() => handleSelect("purchase")} type="primary" className="w-full">
          Purchase number
        </Button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
